import React, { useRef, useState } from 'react';
import {
  Typography,
  Modal,
  Layout,
  MenuProps,
  Menu,
  ConfigProvider,
  Space,
  Pagination,
  Row,
  Col,
} from 'antd';

import Loader from './Loader';
import RecordsList from '../Content/RecordList';
import { FilterBar } from '../Header/FilterBar';
import RecordItem from '../Content/RecordItem';
import ListItem from '../Content/ListItem';
import EmptyRecord from '../Content/EmptyRecord';
import PageHeading from './PageHeading';
import PdfViewer from '../PDF/PDFViewer';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import { logNewsletterEvent } from '../../services/ApiActions/newsletterAct';
const { Sider, Content } = Layout;
const { Title } = Typography;

type MenuItem = Required<MenuProps>['items'][number];

interface NewsletterLayoutProps {
  pagination?: React.ReactNode;
  tabs: any;
  title: string;
  records: any[];
  selectedMenu?: any;
  menuItems: any;
  isLoading?: boolean;
  defaultDateRange?: any;
  selectedTab: any;
  onRangeChange?: any;
  onPriorityChange?: any;
  priority?: any;
  onAllClick: any;
  onTabClick: any;
  isNewsletter?: boolean;
  includeDateInHeading?: boolean;
  showPriorityFilter?: boolean;
  tabItemsCount?: any;
  showDateRange?: boolean;
  dateFilterComponent?: React.ReactNode;
  selectedDateOption?: string;
}

const NewsletterLayout: React.FC<NewsletterLayoutProps> = ({
  pagination,
  tabs,
  title,
  records,
  selectedMenu,
  menuItems,
  isLoading,
  defaultDateRange,
  onRangeChange,
  onAllClick,
  selectedTab,
  onTabClick,
  isNewsletter,
  includeDateInHeading,
  onPriorityChange,
  priority,
  showPriorityFilter,
  tabItemsCount,
  showDateRange,
  dateFilterComponent,
  selectedDateOption,
}) => {
  const [open, setOpen] = useState(false);
  const [isVideo, setIsVideo] = useState(false);
  const [videoId, setVideoId] = useState('');
  const [playingVideoId, setPlayingVideoId] = useState<string | null>(null);
  const [PDFURL, setPDFURL] = useState('');
  const [PDFTitle, setPDFTitle] = useState('');
  const [currentPDFPage, setCurrentPDFPage] = useState(1);
  const [totalPDFPages, setTotalPDFPages] = useState(1);

  const colSpan =
    records.length > 1 && selectedTab !== 'video' && menuItems.length <= 0
      ? 12
      : 24;
  const headerHeight = '106px';
  const modalEventTimer = useRef<number | null>(null);
  const onReadMoreClick = (articleHeading: string, pdfURL: string) => {
    setOpen(true);
    setPDFURL(pdfURL);
    setPDFTitle(articleHeading);
  };
  const onPlayClick = (
    articleHeading: string,
    videoURL: string,
    id: string
  ) => {
    setVideoId(id);
    setOpen(true);
    setIsVideo(true);
    setPDFURL(videoURL);
    setPDFTitle(articleHeading);
  };
  const handleOnVideoPlay = (isPlaying: string | null) => {
    // If there's already a video playing and we're switching to a different one
    if (
      playingVideoId !== null &&
      isPlaying !== null &&
      playingVideoId !== isPlaying
    ) {
      // Track the previously playing video before switching

      trackCall('Video');
      // Start tracking the new video
      modalEventTimer.current = Date.now();
    }
    // If no video was playing before and we're starting one now
    else if (playingVideoId === null && isPlaying !== null) {
      modalEventTimer.current = Date.now();
    }
    // If we're pausing the video (isPlaying becomes null)
    else if (playingVideoId !== null && isPlaying === null) {
      trackCall('Video');
      modalEventTimer.current = null;
    }

    // Update the currently playing video ID
    setPlayingVideoId(isPlaying);
  };
  const trackCall = (mediaType: string) => {
    const trackingData: any = {
      media_type: mediaType,
      title: PDFTitle,
    };

    let engagedTime = 0;
    if (modalEventTimer.current !== null) {
      engagedTime = (Date.now() - modalEventTimer.current) / 1000;
      modalEventTimer.current = null; // Reset after usage
    }

    if (mediaType.toLowerCase() === 'pdf') {
      const pdfReadPercentage = (currentPDFPage / totalPDFPages) * 100;
      trackingData.pdf_read_percentage = Number(pdfReadPercentage.toFixed(2));
    }
    if (engagedTime > 0) {
      trackingData.duration = Number(engagedTime.toFixed(2));
      logNewsletterEvent(trackingData);
    }
  };
  return (
    <>
      <Layout>
        <PageHeading heading={title} />
        <Layout>
          {menuItems.length > 0 && (
            <Sider
              width={220}
              style={{
                backgroundColor: 'transparent',
                maxHeight: `calc(100vh - ${headerHeight})`,
                overflow: 'auto',
              }}
            >
              <ConfigProvider
                theme={{
                  components: {
                    Menu: {
                      itemSelectedBg: '#001e5a',
                      itemSelectedColor: '#FFF',
                    },
                  },
                }}
              >
                <Menu
                  key={Math.random()}
                  className="secondary-menu"
                  defaultSelectedKeys={[selectedMenu]}
                  style={{
                    backgroundColor: 'transparent',
                    height: '100%',
                    borderRight: 0,
                  }}
                  items={menuItems}
                />
              </ConfigProvider>
            </Sider>
          )}

          <Content
            style={{
              height: `calc(100vh - ${headerHeight})`,
              marginLeft: menuItems.length > 0 ? '20px' : 0,
              //marginTop: menuItems.length > 0 ? '3px' : 0,
            }}
          >
            {
              <FilterBar
                tabs={selectedMenu === 'submenu-performance-report' ? [] : tabs}
                selectedTab={selectedTab}
                onTabClick={onTabClick}
                onAllClick={onAllClick}
                onRangeChange={onRangeChange}
                defaultDateRange={defaultDateRange}
                onPriorityChange={onPriorityChange}
                priority={priority}
                showPriorityFilter={showPriorityFilter}
                showDateRange={showDateRange}
                rangePresets={undefined}
                dateFormat={''}
                dateFilter={dateFilterComponent}
                selectedDateOption={selectedDateOption}
              />
            }

            {isLoading ? (
              <Loader style={{ marginTop: '20%', justifyContent: 'center' }} />
            ) : (
              <>
                <div
                  style={{
                    height: 'calc(100vh - 182px)',
                    paddingRight: '10px',
                    overflowY: 'auto',
                  }}
                >
                  <div
                    className={
                      selectedTab === 'video' ? 'video-tab-content' : ''
                    }
                  >
                    {records.length > 0 ? (
                      <Row gutter={[16, 16]}>
                        {records.map((item) => (
                          <Col span={colSpan}>
                            <ListItem
                              hasNoSidebar={true}
                              playingVideoId={playingVideoId}
                              includeDateInHeading={includeDateInHeading}
                              isNewsletter={isNewsletter}
                              key={item.id}
                              item={item}
                              selectedTab={selectedTab}
                              priority={priority}
                              onReadMoreClick={onReadMoreClick}
                              onPlayClick={onPlayClick}
                              onVideoPlay={(isPlaying, title) => {
                                setPDFTitle(title);
                                handleOnVideoPlay(isPlaying);
                              }}
                              onVideoEnd={() => {
                                trackCall('Video');
                              }}
                            />
                          </Col>
                        ))}
                      </Row>
                    ) : (
                      <EmptyRecord />
                    )}
                  </div>

                  {/* <RecordsList
                tabs={tabs}
                priority={priority}
                isNewsletter={isNewsletter}
                records={records}
                selectedTab={selectedTab}
                onReadMoreClick={onReadMoreClick}
              /> */}
                </div>
                {pagination}
              </>
            )}

            <Modal
              title={PDFTitle}
              footer={null}
              centered
              open={open}
              onCancel={() => {
                setOpen(false);
              }}
              width={isVideo ? 800 : 1200}
              afterClose={() => {
                trackCall(isVideo ? 'Video' : 'Pdf');
                setIsVideo(false);
                setPDFURL('');
              }}
              destroyOnClose
            >
              {isVideo ? (
                <VideoPlayer
                  id={videoId}
                  playingVideoId={playingVideoId}
                  onVideoPlay={(id) => {
                    setPlayingVideoId(id);
                    if (id) {
                      modalEventTimer.current = Date.now();
                    }
                  }}
                  videoURL={PDFURL}
                  onVideoPause={() => {
                    trackCall('Video');
                  }}
                  onVideoEnd={() => {
                    trackCall('Video');
                  }}
                />
              ) : (
                <PdfViewer
                  fileUrl={PDFURL}
                  onLoad={(total) => {
                    setTotalPDFPages(total);
                    modalEventTimer.current = Date.now();
                  }}
                  onPageChange={(current) => {
                    if (current > currentPDFPage) {
                      setCurrentPDFPage(current);
                    }
                  }}
                />
              )}
            </Modal>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default NewsletterLayout;
